import { BannerApi as BannerApiClient } from 'pleinchamp-api-client/dist/src/banner/banner';
import React, { MouseEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApiConfiguration, axiosInstance } from '@api/business/api.conf';
import { FadeInElement } from '@components/animations/FadeInElement/FadeInElement.component';
import { CloseIcon } from '@components/icons/Close.icon';
import { Text } from '@components/Text/Text.component';
import { Toolbar } from '@material-ui/core';
import { PlcDispatch, RootState } from '@store/store';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import styles from './Banner.module.scss';

const BannerApi = new BannerApiClient(ApiConfiguration, undefined, axiosInstance);

const Banner: React.FunctionComponent = () => {
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const {
    layout: { setAppBanner },
  } = useDispatch<PlcDispatch>();
  const state = useSelector(({ layout }: RootState) => ({
    enabled: layout.appBanner.enabled,
    text: layout.appBanner.text,
  }));

  useEffect(() => {
    (async () => {
      const { enabled, text } = (await BannerApi.banner()).data;
      if (enabled && text !== '') {
        setAppBanner({ enabled, text });
      }
    })();
  }, [setAppBanner]);

  const handleOnClick = (event: MouseEvent) => {
    event.preventDefault();
    setAppBanner({ enabled: false, text: state.text });
  };

  return (
    <FadeInElement className={styles['fade-app-banner']} show={state.enabled}>
      <div className={styles['app-banner']}>
        <Toolbar className={styles['app-banner-toolbar']}>
          <Text className={styles['app-banner-text']} flavour="light" variant={isMobile ? 'tiny-title' : 'h6'}>
            {state.text}
          </Text>
          <CloseIcon className={styles['app-banner-close-icon']} fillColor="#fff" onClick={handleOnClick} />
        </Toolbar>
      </div>
    </FadeInElement>
  );
};

export { Banner };
